import React, { Component } from "react";
import { size, isEmpty } from "lodash";
import { Modal, ModalBody, Button, Input } from "reactstrap";
import CKEditorUI from "../../components/CKEditor/CKEditorUI";
import { objectEncode } from "../../utils/updateObject";
import axios from "../../axios";
import * as url from "../../utils/url";

import { placeholder_text} from "../../utils/constants";



export default class CreateEOModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      privacy: "PRIVATE",
      description: {
        value: "",
        error: false,
      },
      title: {
        value: "",
        error: false,
      },
    };
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.description.value) {
        this.setState({ description: this.props.description });
      } else {
        this.setState({
          description: {
            value: `<p>${placeholder_text.action_create}</p>\n`,
            error: false,
          },
        });
      }
      if (this.props.title.value) {
        this.setState({ title: this.props.title });
      }
    }, 300);
  }

  handleChangeObjectiveDescription = event => {
    const descriptionContext = event.editor.getData();
    this.setState({ description: { value: descriptionContext } });
  };

  handleChangeObjectiveTitle = event => {
    const { value } = event.target;
    this.setState({ title: { value: value } });
  };

  handleSubmitObjective = () => {
    const { description, title, privacy } = this.state;
    const { taskType, objectiveId } = this.props;
    let desc = description.value.replace(/<\/?[^>]+(>|$)/g, "");
    let d_string = description.value.replace(/^\s+|\s+$/g, "");

    if (desc.length > 0 && title.value.length > 0) {
      if (taskType === "Update") {
        let payload = {
          description: d_string,
          title: title.value,
          privacy,
          _id: objectiveId,
        };
        axios
          .post(url.updateEnterpriseObjective, objectEncode(payload))
          .then(({ data }) => {
            const item = data.data;
            this.props.handleUpdateObjInTable(item);
          });
      } else {
        let payload = {
          description: d_string,
          title: title.value,
          privacy,
        };
        axios
          .post(url.addEnterpriseObjective, objectEncode(payload))
          .then(({ data }) => {
            const newObjective = data.data;
            this.props.handleAppendObjInTable(newObjective);
          });
      }
      this.setState({ showModal: false, description: "", title: "" });
    }
  };
  render() {
    const { title, description } = this.state;
    return (
      <Modal isOpen={this.props.showModal}>
        <ModalBody style={{ padding: "30px" }}>
          <div className="row">
            <div className="weeklyWinTitle pick-office-modal-body-title">{`${this.props.taskType} an Enterprise Objective`}</div>
          </div>
          <span className="addTaskHeaders">Title</span>
          <div className="inner-addon right-addon">
            <span className="name-hint-max-length name-char-count-txt">{`${size(
              title.value
            )}/64`}</span>
            <Input
              type="text"
              name="objectiveTitle"
              onChange={this.handleChangeObjectiveTitle}
              value={title.value}
              maxLength={64}
            />
          </div>

          <div className="addTaskHeaders mt20">Description</div>
          <CKEditorUI
            onChange={this.handleChangeObjectiveDescription}
            value={description.value}
          />
          <div style={{ padding: "10px 0px 0px 0px" }}>
            <Button
              className="profile-modal-save-btn float-left weeklyWinBtn"
              onClick={this.handleSubmitObjective}
              disabled={isEmpty(description.value && title.value)}
            >
              <span className="profile-modal-save-btn-txt">
                Create<span className="ml10 flaticon-tick"></span>
              </span>
            </Button>
            <Button
              className="profile-modal-cancel-btn float-right weeklyWinBtn"
              onClick={this.props.closeEnterpriseAddModal}
            >
              <span className="profile-modal-cancel-btn-txt">Cancel</span>
            </Button>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}
